<template>
  <div class="o-ring-calculator__container">
    <div
      class="o-ring-calculator__container__cards"
      v-for="(row, rowIdx) in cardRows"
      :key="rowIdx"
    >
      <div
        class="card"
        v-for="(card, cardIdx) in row"
        :key="card.title"
      >
        <div class="card-content">
          <h2 class="h4">
            {{ $tv(card.title, "ORingConfiguratorImport") }}
          </h2>
          <div class="card-content__container">
            <div class="card-content__description">
              {{ $tv(card.description, "ORingConfiguratorImport") }}
            </div>
            <div
              v-if="getCardImage(rowIdx, cardIdx)"
              class="card-image"
            >
              <img loading="lazy"
                :src="getCardImage(rowIdx, cardIdx).src"
                :alt="getCardImage(rowIdx, cardIdx).alt"
              >
            </div>
          </div>
          <div class="card-content__button">
            <NuxtLink
              :to="app.$globalization.localePath(card.path)"
              class="k-button k-button-md k-button-solid k-button-solid-base"
            >
              {{ $tv('open', 'ORingConfigurator') }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import oRingAssistantImg from '@/assets/images/o-ring-assistant.png'
import oRingDesignCockpitImg from '@/assets/images/O-Ring_DesignCockpit.png'

const app = useNuxtApp()

const cardRows = [
  [
    {
      title: 'Frontend.ORing.Assistant',
      description: 'Frontend.ORing.AssistantDescription',
      path: '/oring-calculator/oring-assistant'
    },
    {
      title: 'Frontend.ORing.ExpertMode',
      description: 'Frontend.ORing.ExpertModeDescription',
      path: '/oring-calculator/design-cockpit'
    }
  ],
  [
    {
      title: 'Frontend.ORing.DesignSpaceAssis',
      description: 'Frontend.Oring.DesignAssistantDescription',
      path: '/oring-calculator/design-space-assistant'
    },
    {
      title: 'Frontend.ORing.MaterialAssis',
      description: 'Frontend.Oring.MaterialAssistantDescription',
      path: '/oring-calculator/material-assistant'
    }
  ]
]

function getCardImage(rowIdx: number, cardIdx: number) {
  if (rowIdx === 0 && cardIdx === 0) {
    return {
      src: oRingAssistantImg,
      alt: 'O-Ring Assistant'
    }
  }
  if (rowIdx === 0 && cardIdx === 1) {
    return {
      src: oRingDesignCockpitImg,
      alt: 'Design Cockpit'
    }
  }
  return null
}
</script>
<style lang="scss">
.o-ring-calculator__container {
  width: 100%;
  margin-bottom: 2rem;

  &__cards {
    display: flex;
    width: 100%;

    .card {
      width: 50%;
      padding: 1rem;
      margin: 2rem .625rem 0;

      h2 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: $base-text-font-weight-semi-bold;
        line-height: 1.5rem;
      }

      .card-content__container {
        display: flex;
        justify-content: space-between;

        .card-image {
          img {
              width: 11.5625rem;
              height: 11.5625rem;
            }
        }
      }

      .card-content__button {
        display: flex;
        justify-content: flex-end;
        padding-top: 1rem;
      }

      .card-content__description {
        padding-top: 1rem;
        line-height: 1.125rem;
        font-weight: $base-text-font-weight-light;
      }
    }

    .card:first-child {
      margin-left: 0;
    }

    .card:last-child {
      margin-right: 0;
    }

    &:nth-child(2) .card {
      margin-top: 1.25rem;
    }

    @include breakpoint-down($md) {
      flex-direction: column;

      .card {
        width: calc(100% - 2rem);
        padding: 1rem;
        margin: 2rem 0 1rem;
        box-shadow: $shadow-default;
      }

      &:nth-child(2) .card {
        margin-top: 2rem;
      }

      .card:first-child {
        margin-bottom: 0;
      }

      .card:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
